import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_DigitalIDActivations } from "../shared/data.service";
import { DebugQRRequest } from "../shared/DebugQRRequest";
import * as moment from "moment";

@Component({
	selector: "app-digital-id-debug-qr-code",
	templateUrl: "./digital-id-debug-qr-code.component.html",
	styleUrls: ["./digital-id-debug-qr-code.component.css"],
})
export class DigitalIdDebugQrCodeComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private DigitalIDActivationService: DataService_DigitalIDActivations) {}

	ngOnInit(): void {
		this.loadURL();
	}

	/////////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////////

	QRCodeB64: string = "";
	PlainText: string = "";
	EncryptedText: string = "";

	PersonID: string = "0";
	ExpireDate: Date = new Date();
	URL: string = "";

	LoadingURL: boolean = false;
	LoadingQR: boolean = false;

	TextToDecrypt: string = "";
	DecryptedText: string = "";

	/////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////////
	loadURL() {
		this.LoadingURL = true;

		var result = this.DigitalIDActivationService.DebugQRSelectInfo();
		result.subscribe(
			(response: any) => {
				this.LoadingURL = false;

				this.URL = response.URL;

				this.loadQRCode();
			},
			(error) => {
				this.LoadingURL = false;
			}
		);
	}

	loadQRCode() {
		this.LoadingQR = true;

		var feDate = moment(this.ExpireDate).format("MM/DD/YYYY");

		var parms: DebugQRRequest = {
			PersonID: this.PersonID,
			ExpireDate: feDate,
			URL: this.URL,
			TextToDecrypt: this.TextToDecrypt,
		};

		var result = this.DigitalIDActivationService.DebugQRLoadQR(parms);
		result.subscribe(
			(response: any) => {
				this.LoadingQR = false;

				this.PlainText = response.PlainText;
				this.EncryptedText = response.EncryptedText;
				this.QRCodeB64 = response.QRCodeB64;

				this.DecryptedText = "";
				this.DecryptedText = response.DecryptedText;
			},
			(error) => {
				this.LoadingQR = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////////
	onRefresh() {
		this.loadQRCode();
	}

	onClose() {
		this.ref.close(0);
	}
	/////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////////////
	IsLoading() {
		return this.LoadingURL == true || this.LoadingQR == true;
	}
	/////////////////////////////////////////////////////////////////////////////
}
